<template>
    <div>
        <el-drawer
            title="创建场地"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
                <el-form
                    :model="formData"
                    :rules="rules"
                    ref="formData"
                    label-position="top"
                    v-loading="dataLoading"
                >
                    <el-row :gutter="20">
                        <el-col :xs="24" :md="12"> 
                            <el-form-item prop="name" label="场地名称:"><el-input v-model="formData.name" placeholder="请输入场地名称" size="medium" :maxlength="40"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :md="12"> 
                            <el-form-item prop="capacity" label="容纳人数:">
                                <el-input-number style="width:100%" v-model="formData.capacity" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入容纳人数"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>  
                    <el-row :gutter="20">  
                        <el-col :xs="24" :md="12"> 
                            <el-form-item prop="freeTicketNum" label="赠票数量上限:">
                                <el-input-number style="width:100%" v-model="formData.freeTicketNum" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入赠票数量上限"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :md="12"> 
                            <el-form-item prop="city" label="所在城市">
                                <el-cascader
                                    v-model="formData.city"
                                    :options="cityList"
                                    filterable
                                    :props="{label:'name',children:'cityList',value:'code',emitPath:false}"
                                    size="medium"
                                    style="width:100%"
                                    ref="cityCascader"
                                    @change="cityChange">
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-if="customSite && customSite.address">
                        地址: {{cityName}} {{customSite.address}} <span class="color-danger">【用户填写的地址】</span>
                        <el-button size="mini" type="text" icon="el-icon-document-copy" @click="copy">复制</el-button>
                        <input class="copyTool" ref="copyTool" :value="cityName+customSite.address" />
                    </div>
                    <el-form-item prop="longitude" >
                        <span slot="label">
                            坐标地址:
                            <el-button type="text" icon="el-icon-map-location" @click="$refs.selectAddress.show()">选择地址</el-button> 
                            <small style="margin-left:10px" v-if="formData.longitude">(经度: {{formData.longitude}} 纬度: {{formData.latitude}})</small>
                        </span>
                        <div class="color-warning">请仔细核对地图坐标，这将用于APP演出定位</div>
                        <el-input v-model="formData.address" placeholder="百度地图根据搜索结果返回的地址" size="medium" maxlength="100"></el-input>
                    </el-form-item>
                    <el-form-item prop="siteType" label="场地类型:">
                        <el-select v-model="formData.siteType" placeholder="请选择场地类型" size="medium">
                            <el-option v-for="item in siteTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="contact" label="咨询电话:">
                        <el-input v-model="formData.contact" placeholder="请输入咨询电话号码" size="medium"></el-input>
                    </el-form-item>
                    <div v-if="customSite" class="MT20">
                        <el-button type="primary" @click="submitForm()" :loading="btnLoading">创建场地并绑定</el-button>
                        <el-button type="warning" @click="isBindSite = true" :loading="btnLoading">仅绑定场地</el-button>
                    </div>
                </el-form>
                <!-- 如果是自定义场地，可绑定正式场地，否则无需绑定 -->
                <el-form v-if="isBindSite" :model="bindSiteForm" ref="bindSiteForm" label-position="top" class="MT20">
                    <el-form-item prop="value" :rules="[{ required: true, message: '请选择演出场地' }]">
                        <span slot="label">绑定正式场地: </span>
                        <el-select v-model="bindSiteForm.value" filterable remote placeholder="请输入演出场地"
                            :remote-method="searchSite" :loading="userLoading" size="medium" value-key="id">
                            <el-option v-for="item in siteList" :key="item.id" :label="item.name" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="MT20">
                        <el-button type="primary" @click="bindSite()" :loading="btnLoading">完成绑定</el-button>
                    </div>
                </el-form>
            </div>
            <div v-if="!customSite" class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                    >提交</el-button
                >
            </div>
        </el-drawer>

        <select-address 
            ref="selectAddress" 
            :address.sync="formData.address" 
            :lng.sync="formData.longitude" 
            :lat.sync="formData.latitude">
        </select-address>
    </div>
</template>

<script>
import {fetchAllCity , fetchUser } from '@/assets/js/commonApi'
import SelectAddress from '@/components/SelectAddressBaiduMap';
const defaultFormData = {
    name: "",
    capacity: '',
    freeTicketNum:10,
    city:10,
    // password:'Thshowstart123',
    contact:'',
    latitude:'',
    longitude:'',
    address:'',
    siteType: "",
}
export default {
    components:{
        SelectAddress
    },
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                name: [{ required: true, message: "请输入场地名称" }],
                capacity: [{ required: true, message: "请输入容纳人数" }],
                freeTicketNum:[{ required: true, message: "请输入赠票数量上限" }],
                city:[{required: true, message: '请选择所在城市'}],
                longitude:[{required: true, message: '请通过百度地图选择坐标地址'}],
                siteType: [{ required: true, message: "请选择场地类型" }],
            },
            cityList:[],//所有省份城市集合
            customSite: null,
            cityName:'',
            siteTypeList: [],

            isBindSite: false,
            bindSiteForm: {
                value: ''
            },
            siteList: [],
            userLoading: false,
        };
    },
    mounted(){
        this.getCityList()
        this.getSiteType();
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(customSite) {
            this.bindSiteForm.value = '';
            this.customSite = customSite || null;
            this.formData = {
                ...this.formData,
                ...customSite,
                name: customSite && customSite.name || '',
                city: customSite && parseInt(customSite.cityCode) || this.formData.city,
                siteType: customSite?.siteType || '',
                contact: customSite?.telephone || ''
            }
            this.drawerShow = true;
            
            this.$nextTick(() => {
                this.cityChange()
            })
        },
        cityChange(){
            const _node = this.$refs.cityCascader.getCheckedNodes();
            console.log(_node)
            this.cityName = _node && _node[0].parent.label+_node[0].label;
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //获取场地类型
        getSiteType(){
            this.$request({
                url: "/styleTag/showType/site/all",
                method: "post",
            }).then(res => {
                const { state, result } = res.data;
                if(state == 1){
                    this.siteTypeList = [...result]
                }
            }) 
        },
        // 搜索场地
        async searchSite(query) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: 3,
                }).finally(() => {
                    this.userLoading = false;
                });

                const {
                    state,
                    result
                } = res.data;

                if (state == 1 && result) {
                    this.siteList = result;
                }
            }
        },
        //表单提交
        submitForm() {
            // console.log(this.formData)
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = "/site/save";
                    this.btnLoading = true;

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg, result } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate',result);
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        //绑定场地
        bindSite(){
            this.$refs["bindSiteForm"].validate((valid) => {
                if (valid) {
                    this.$emit('bindSite', this.bindSiteForm.value);
                    this.close();
                }
            })
        },
        //复制地址
        copy(){
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        },
    },
};
</script>

<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>